// src/app/store/version/version.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as VersionActions from './version.actions';
import { BackendVersion } from '../../services/version.service';

export interface VersionState {
  data: BackendVersion | null;
  loading: boolean;
  error: any;
}

export const initialState: VersionState = {
  data: null,
  loading: false,
  error: null
};

export const versionReducer = createReducer(
  initialState,
  on(VersionActions.loadBackendVersion, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(VersionActions.loadBackendVersionSuccess, (state, { version }) => ({
    ...state,
    data: version,
    loading: false
  })),
  on(VersionActions.loadBackendVersionFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),
  on(VersionActions.resetBackendVersion, () => initialState)
);